import React, { useEffect } from "react";

// Default flat data
const defaultWorkersBenefitData = [
  "Permanent Workers",
  "Other than Permanent Workers",
].flatMap((employeeType) =>
  ["Male", "Female", "Total"].map((category) => ({
    employeeType,
    category,
    total: "",
    health: { number: "", percent: "" },
    accident: { number: "", percent: "" },
    maternity: { number: "", percent: "" },
    paternity: { number: "", percent: "" },
    daycare: { number: "", percent: "" },
  }))
);

// Benefit headers
const benefitHeaders = [
  { key: "health", label: "Health Insurance", numKey: "B", percentKey: "B/A" },
  {
    key: "accident",
    label: "Accident Insurance",
    numKey: "C",
    percentKey: "C/A",
  },
  {
    key: "maternity",
    label: "Maternity Benefits",
    numKey: "D",
    percentKey: "D/A",
  },
  {
    key: "paternity",
    label: "Paternity Benefits",
    numKey: "E",
    percentKey: "E/A",
  },
  {
    key: "daycare",
    label: "Day Care Facilities",
    numKey: "F",
    percentKey: "F/A",
  },
];

const employeeTypeGroups = [
  "Permanent Workers",
  "Other than Permanent Workers",
];

const WorkersBenefitCoverageTable = ({
  workersbenefitTable,
  setWorkersBenefitTable,
}) => {
  // 👇 Initialize with default data only if not already set
  useEffect(() => {
    if (
      !Array.isArray(workersbenefitTable) ||
      workersbenefitTable.length === 0
    ) {
      setWorkersBenefitTable(defaultWorkersBenefitData);
    }
  }, [workersbenefitTable, setWorkersBenefitTable]);

  // Safeguard for initial undefined
  if (!Array.isArray(workersbenefitTable)) return null;

  const handleChange = (employeeType, category, benefitKey, field, value) => {
    const index = workersbenefitTable.findIndex(
      (r) => r.employeeType === employeeType && r.category === category
    );
    if (index === -1) return;

    const updated = [...workersbenefitTable];
    if (benefitKey === "total") {
      updated[index].total = value;
    } else {
      updated[index][benefitKey][field] = value;
    }
    setWorkersBenefitTable(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="3" style={headerStyle}>
              Category
            </th>
            <th rowSpan="3" style={headerStyle}>
              Total (A)
            </th>
            <th colSpan={benefitHeaders.length * 2} style={headerStyle}>
              % of Workers Covered By
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            {benefitHeaders.map((b) => (
              <th key={b.key} colSpan="2" style={headerStyle}>
                {b.label}
              </th>
            ))}
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            {benefitHeaders.map((b) => (
              <React.Fragment key={b.key}>
                <th style={headerStyle}>Number ({b.numKey})</th>
                <th style={headerStyle}>% ({b.percentKey})</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {employeeTypeGroups.map((type) => (
            <React.Fragment key={type}>
              <tr>
                <td
                  colSpan={2 + benefitHeaders.length * 2}
                  style={{ ...groupHeaderStyle, textAlign: "center" }}
                >
                  {type}
                </td>
              </tr>
              {["Male", "Female", "Total"].map((cat) => {
                const row = workersbenefitTable.find(
                  (r) => r.employeeType === type && r.category === cat
                );
                if (!row) return null;

                return (
                  <tr key={`${type}-${cat}`}>
                    <td style={{ ...cellStyle, fontWeight: "bold" }}>{cat}</td>
                    <td style={cellStyle}>
                      <input
                        type="text"
                        placeholder="Total"
                        value={row.total}
                        onChange={(e) =>
                          handleChange(type, cat, "total", null, e.target.value)
                        }
                        style={inputStyle}
                      />
                    </td>
                    {benefitHeaders.map((b) => (
                      <React.Fragment key={b.key}>
                        <td style={cellStyle}>
                          <input
                            type="text"
                            placeholder="No."
                            value={row[b.key]?.number || ""}
                            onChange={(e) =>
                              handleChange(
                                type,
                                cat,
                                b.key,
                                "number",
                                e.target.value
                              )
                            }
                            style={inputStyle}
                          />
                        </td>
                        <td style={cellStyle}>
                          <input
                            type="text"
                            placeholder="%"
                            value={row[b.key]?.percent || ""}
                            onChange={(e) =>
                              handleChange(
                                type,
                                cat,
                                b.key,
                                "percent",
                                e.target.value
                              )
                            }
                            style={inputStyle}
                          />
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
                );
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const groupHeaderStyle = {
  padding: "8px",
  backgroundColor: "#e7dfe2",
  fontWeight: "bold",
  border: "1px solid #000",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid grey",
  outline: "none",
};

export default WorkersBenefitCoverageTable;
